import LogoVip from '../src/LogoVip';
export default LogoVip;
